(function () {
  'use strict';

  /*
    Ürün Varlık Muhafızı (Product Availability Guard)
    -------------------------------------------------
    Sorun: Bir ürün arşivlendiğinde/silindiğinde ürün sayfası ANINDA 404 olur,
    ancak Shopify'ın storefront ARAMA INDEX'i asenkron güncellenir. Bu yüzden
    arşivlenen "hayalet" ürünler arama sonuçlarında (ve filtreli koleksiyonlarda)
    kart olarak kalmaya devam eder — tıklanınca 404 verir.

    Liquid'de `product.status` YOK, dolayısıyla server-side eleme mümkün değil
    (hayalet kartlar `available:true` bile raporlar). Tek hızlı çözüm client-side:
    her kartın `/products/{handle}.js` endpoint'ine hafif bir HEAD isteği atarız.
    - 404/410 => ürün gerçekte yok => kartı gizle.
    - 200     => canlı => dokunma (stoksuz olsa bile geçerli ürün).
    - diğer   => (429/5xx/ağ hatası) => HİÇBİR ŞEY YAPMA (fail-open: asla yanlışlıkla gizleme).

    HEAD gövde indirmez (size_download=0), aynı origin olduğu için CORS yok.
    Sonuçlar sessionStorage'da kısa süre cache'lenir; eşzamanlılık sınırlanır.
  */

  var CACHE_PREFIX = 'pag:';
  var CACHE_TTL = 30 * 60 * 1000; // 30 dakika
  var MAX_CONCURRENT = 5;
  var HIDDEN_CLASS = 'collection-grid__item--unavailable';

  if (!('fetch' in window)) return;

  /* ---- Ürün path'i çıkar: /products/{handle} (locale prefix'i ve variant query'sini atar) ---- */
  function productPathFromItem(item) {
    var link = item.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var href = link.getAttribute('href');
    if (!href) return null;
    var url;
    try { url = new URL(href, window.location.origin); } catch (e) { return null; }
    var m = url.pathname.match(/\/products\/[^/?#]+/);
    return m ? m[0] : null;
  }

  /* ---- sessionStorage cache ---- */
  function cacheGet(path) {
    try {
      var raw = sessionStorage.getItem(CACHE_PREFIX + path);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || (Date.now() - obj.t) > CACHE_TTL) return null;
      return obj.s; // 'alive' | 'dead'
    } catch (e) { return null; }
  }
  function cacheSet(path, state) {
    try {
      sessionStorage.setItem(CACHE_PREFIX + path, JSON.stringify({ s: state, t: Date.now() }));
    } catch (e) {}
  }

  /* ---- Eşzamanlılık havuzu ---- */
  var queue = [];
  var active = 0;
  function pump() {
    while (active < MAX_CONCURRENT && queue.length) {
      var job = queue.shift();
      active++;
      job().then(function () { active--; pump(); }, function () { active--; pump(); });
    }
  }
  function enqueue(job) { queue.push(job); pump(); }

  function hide(item) {
    item.classList.add(HIDDEN_CLASS);
    item.setAttribute('hidden', '');
    item.setAttribute('aria-hidden', 'true');
  }

  function checkItem(item) {
    if (item.dataset.pagChecked) return;
    item.dataset.pagChecked = '1';

    var path = productPathFromItem(item);
    if (!path) return;

    var cached = cacheGet(path);
    if (cached === 'dead') { hide(item); return; }
    if (cached === 'alive') return;

    enqueue(function () {
      return fetch(path + '.js', { method: 'HEAD' })
        .then(function (res) {
          if (res.status === 404 || res.status === 410) {
            cacheSet(path, 'dead');
            hide(item);
          } else if (res.status === 200) {
            cacheSet(path, 'alive');
          }
          // Diğer durumlar (429/5xx/0): fail-open — gizleme yok, cache yok.
        })
        .catch(function () { /* ağ hatası => fail-open */ });
    });
  }

  function scan(root) {
    (root || document).querySelectorAll('.collection-grid__item').forEach(checkItem);
  }

  /* ---- Infinite-scroll ve reviews-sorted grid gibi sonradan eklenen kartları yakala ---- */
  function observeGrids() {
    if (!('MutationObserver' in window)) return;
    document.querySelectorAll('.collection-grid').forEach(function (grid) {
      if (grid.dataset.pagObserved) return;
      grid.dataset.pagObserved = '1';
      var mo = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (node.classList && node.classList.contains('collection-grid__item')) {
              checkItem(node);
            } else if (node.querySelectorAll) {
              node.querySelectorAll('.collection-grid__item').forEach(checkItem);
            }
          });
        });
      });
      mo.observe(grid, { childList: true });
    });
  }

  function start() {
    scan(document);
    observeGrids();
  }

  function boot() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(start, { timeout: 2000 });
    } else {
      setTimeout(start, 300);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Tema editöründe section yeniden yüklenince yeni grid'leri de kapsa */
  document.addEventListener('shopify:section:load', function () {
    observeGrids();
    scan(document);
  });
})();
